import React from "react";

import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * @see Tooltip
 */

export const IgTooltip: any = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }}>
      <span>{props.children}</span>
    </Tooltip>
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    "& .MuiTypography-root": {
      color: "white",
      fontSize: "13px",
    },
  },
}));
